import apiClient from '../apiClient';

export interface WebappConfig {
  cial_auth_url: string;
  cial_client_id: string;
  env: string;
  is_local: boolean;
  kyx_free_entities_limit: number | null;
  kyx_base_token_price: number | null;
  // "per_check" -> extra entities cost the sum of enabled check prices.
  // "per_entity" -> extra entities cost a flat kyx_per_entity_token_price.
  kyx_excess_pricing_mode: string | null;
  kyx_per_entity_token_price: number | null;
  min_topup_tokens: number | null;
}

export default {
  /**
   * Fetches the web application configuration from the backend.
   */
  getConfig: async (): Promise<WebappConfig> => {
    return await apiClient.get<WebappConfig>('/webapp-config/');
  }
};
